import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import useHomepage from '../../hooks/useHomepage'
import ScrollAnimation from '../scroll-animation/Container'

type Props = {
  productOffering: string
}

const Heading: React.FC<Props> = ({ productOffering }) => {
  const { t } = useTranslation()
  const { animationProps } = useHomepage()

  return (
    <>
      <ScrollAnimation {...animationProps}>
        <div className="plans__title">{t('Insane prices, Unlimited options')}</div>
      </ScrollAnimation>
      <ScrollAnimation {...animationProps}>
        {productOffering === 'dinner' ? (
          <div className="plans__subtitle">
            {t(
              'All meals are reserved on a credit system. Choose the membership option that’s right for your family. You may add credits or cancel at any time.',
            )}
          </div>
        ) : (
          <div className="plans__subtitle">{t('Meals are served every weekday, excluding holidays.')}</div>
        )}
      </ScrollAnimation>
    </>
  )
}

export default Heading
